import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Автоматически скрываем сообщение через 5 секунд
    setTimeout(() => {
      this.close()
    }, 5000)
  }

  close() {
    this.element.style.transition = 'opacity 0.3s ease-out'
    this.element.style.opacity = '0'

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
